import {
  TOGGLE_CHARGE_CARD_FEEDBACK,
  TOGGLE_REMINDER_POPUP,
  CLOSE_ALL_POPUPS,
} from '../actions/popupActions';

const initPopupState = {
  chargeCardFeedback: false,
  reminderPopup: false,
};

export default (state = initPopupState, action) => {
  switch (action.type) {
    case TOGGLE_CHARGE_CARD_FEEDBACK:
      return { ...state, chargeCardFeedback: !state.chargeCardFeedback };

    case TOGGLE_REMINDER_POPUP:
      return { ...state, reminderPopup: action.open };

    case CLOSE_ALL_POPUPS:
      return initPopupState;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/popupReducer.js